/**
 * @author Jafar Amini in March 2018.
 */
export enum Keyword {
  OK= <any> 'OK',
  DELETED= <any> 'با موفقیت حذف شد ' ,
  NOT_FOUND= <any> ' موردی یافت نشد',
  FAILURE= <any> 'مشکلی رخ داد',
  NOT_DONE= <any> 'انجام نشد',
  USER_NAME_DUPLICATE= <any> 'نام کاربری تکراری است',
}
